import React, { useState } from 'react'
import { Redirect } from 'react-router';

import HTHeader from './HTHeader.js'
import HTFooter  from './HTFooter.js'

function HTFullContent (props) {

  const [clicked, setClicked] = useState(false);

  const content = props.content

  if (clicked) {
    return(<Redirect to="/" push={true}/>)
  }

  return (
    <main>
      <HTHeader />
      <div id="content_container">
        <div id="content_header">
          <img id="content_back_img" alt="back_icon" src="/res/back_icon.png" onClick={() => {setClicked(true)}} />
          <div id="content_title">
            {content.title}
          </div>

          <div id="content_date">
            {/*{content.date_modified}*/}
          </div>

        </div>
        <div id="content_content">
          {content.content}
        </div>
      </div>
      <HTFooter />
    </main>
  )

}

export default HTFullContent

/*onClick={() => {props.changeRoute("/")}}*/



// WEBPACK FOOTER //
// src/components/HTFullContent.js